// @flow
import ChildrenPage from './ChildrenPage';

export default ChildrenPage;
